import React from "react";

const EmptyProcess = () => {
  return (
    <div className="bg-gray-800 border border-gray-700 rounded-2xl p-10 text-center">
      <div className="text-xl text-yellow-400 font-semibold">
        Please setup your form to manage the details
      </div>
    </div>
  );
};

export default EmptyProcess;